import { ColDef, SideBarDef, ValueFormatterParams } from 'ag-grid-community';

import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { setQuickFilter } from '@/app/slices/quickFilter';
import { CustomViews } from '@/components/common/custom-views';
import { EMBRYO_METHOD_OPTIONS } from '@/constants';
import { EMBRYO_STATUS_MAP } from '@/pages/fresh-straw/constants';

export const shipmentTabEmbryoColumnDefs = [
  {
    headerName: '',
    headerTooltip: '',
    width: 10,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    suppressMovable: true,
    lockPosition: true,
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 150,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'donorName',
    headerName: 'Donor',
    width: 150,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'sireName',
    headerName: 'Sire',
    width: 150,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'breedName',
    headerName: 'Breed',
    width: 120,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    filter: 'agSetColumnFilter',
    wrapHeaderText: true,
    filterParams: {
      values: [1, 2, 3, 4, 5, 6, 7, 8],
      valueFormatter: (params: ValueFormatterParams) => {
        return (
          EMBRYO_STATUS_MAP[params.value as keyof typeof EMBRYO_STATUS_MAP] ||
          ''
        );
      },
      buttons: ['apply', 'clear'],
      closeOnApply: true,
    },
    valueFormatter: (params: ValueFormatterParams) => {
      if (params.value === null || params.value === undefined) return '';
      return (
        EMBRYO_STATUS_MAP[params.value as keyof typeof EMBRYO_STATUS_MAP] || ''
      );
    },
  },
  {
    field: 'stage',
    headerName: 'Stage',
    width: 100,
    filter: 'agNumberColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'grade',
    headerName: 'Grade',
    width: 100,
    filter: 'agNumberColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'method',
    headerName: 'Method',
    width: 100,
    filter: 'agSetColumnFilter',
    wrapHeaderText: true,
    filterParams: {
      values: EMBRYO_METHOD_OPTIONS.map((opt) => opt.value),
      valueFormatter: (params: ValueFormatterParams) => {
        return (
          EMBRYO_METHOD_OPTIONS.find((opt) => opt.value === params.value)
            ?.label ?? ''
        );
      },
      buttons: ['apply', 'clear'],
      closeOnApply: true,
    },
    valueFormatter: (params: ValueFormatterParams) => {
      return (
        EMBRYO_METHOD_OPTIONS.find((opt) => opt.value === params.value)
          ?.label ?? ''
      );
    },
  },
  {
    field: 'storageLocationName',
    headerName: 'Storage Location',
    width: 150,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'cane',
    headerName: 'Cane',
    width: 120,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'strawNumber',
    headerName: 'Straw #',
    width: 100,
    filter: 'agNumberColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'ownerName',
    headerName: 'Owner',
    width: 150,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'siteName',
    headerName: 'Site',
    width: 150,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
  {
    field: 'shipmentName',
    headerName: 'Shipment',
    width: 150,
    filter: 'agTextColumnFilter',
    wrapHeaderText: true,
    filterParams: { buttons: ['apply', 'clear'], closeOnApply: true },
  },
] as ColDef[];

export const embryoAppShipmentSideBar: SideBarDef = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
    },
    {
      id: 'customViews',
      labelDefault: 'Custom Views',
      labelKey: 'customViews',
      iconKey: 'custom-views',
      toolPanel: CustomViews,
      toolPanelParams: {
        setQuickFilter,
        useAppDispatch,
        useAppSelector,
      },
    },
  ],
};
